import {create} from 'zustand'
import InformationModal from '../class/InformationModal.ts'
import {getInformationModal} from '../services/InformationModalAPI.ts'
import {hasCookie, setCookie} from '../Tools/Cookie.ts'

interface UseStoreInformationModalInterface {
    modals: InformationModal[]
    count: number
    fetchInformationModal: () => Promise<void>
    hasInformationModal: () => boolean
    isDisplayableModals: (modal: InformationModal) => boolean
    applyLvl: (modal: InformationModal) => void
    storeReadInformationModal: (informationModal: InformationModal) => void
    resetModalInformations: () => void
}

export const useStoreInformationModal = create<UseStoreInformationModalInterface>(
    (set, get): UseStoreInformationModalInterface => ({
        modals: [],
        count: 0,
        fetchInformationModal: async () => {
            const {isDisplayableModals, hasInformationModal} = get()

            if (!hasInformationModal()) {
                await getInformationModal().then(
                    ({data}): void => {
                        set({
                            modals: data.map(
                                (modal) => new InformationModal(modal),
                            ),
                        })
                    },
                )
            }

            const modals = get().modals.filter(
                (modal: InformationModal): boolean =>
                    isDisplayableModals(modal),
            )
            set({modals, count: modals?.length ?? 0})
        },
        hasInformationModal: (): boolean => {
            return get().count > 0
        },
        isDisplayableModals: (modal: InformationModal): boolean => {
            return !hasCookie(modal.getCookieId())
        },
        applyLvl: (modal: InformationModal): void => {
            const {storeReadInformationModal} = get()

            switch (modal.lvl) {
                case 10:
                    storeReadInformationModal(modal)
                    break

                default:
                  storeReadInformationModal(modal)
                  break
            }
        },
        storeReadInformationModal: (
            informationModal: InformationModal,
        ): void => {
            setCookie(
                informationModal.getCookieId(),
                informationModal.id,
                informationModal.end,
            )
        },
        resetModalInformations: (): void => {
          set({modals: [], count: 0})
        }
    }),
)
